// extracted by mini-css-extract-plugin
export default {"feature":"GroupTitleContent_feature__jVxMl"};